import { render } from "./BpmnGateway.vue?vue&type=template&id=e8e45e66&scoped=true"
import script from "./BpmnGateway.vue?vue&type=script&lang=js"
export * from "./BpmnGateway.vue?vue&type=script&lang=js"

import "./BpmnGateway.vue?vue&type=style&index=0&id=e8e45e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e45e66"]])

export default __exports__